import * as VisuallyHiddenAll from '@radix-ui/react-visually-hidden';

export const VisuallyHidden = VisuallyHiddenAll.VisuallyHidden;
export const VisuallyHiddenRoot = VisuallyHiddenAll.Root;
